module.exports = __webpack_public_path__ + "media/customizations/tehaleh/logo-8a3d29d0b35cbf207d1953c85983776e.png";